import cx from 'classnames';
import { EditIcon } from 'src/assets/svg';

type Props = {
    onClick?: () => void;
    name: string;
    role?: string;
    avatar: string;
    rounded?: boolean;
};

export const ProfileBanner = ({
    onClick,
    name,
    role,
    avatar,
    rounded = false,
}: Props) => {
    return (
        <div className="flex flex-col gap-3 pb-2 w-full relative">
            <div className="w-full flex space-x-4 items-center">
                <div className="flex-shrink-0 relative w-24 lg:w-32 xl:w-36 aspect-square">
                    <img
                        className={cx(
                            'absolute inset-0 rounded-full shadow-lg w-full aspect-square object-cover',
                            rounded ? 'rounded-full' : 'rounded-lg',
                        )}
                        src={avatar}
                        alt="Avatar"
                    />
                </div>

                <div>
                    <h1 className="font-bold font-logo text-left font-white text-xl xl:text-3xl lg:leading-normal whitespace-nowrap truncate">
                        {name}
                    </h1>
                    {role && (
                        <p className="text-[12px] md:text-[14px] leading-none mb-3">{`(${role})`}</p>
                    )}
                </div>

                {onClick && (
                    <div className="absolute bottom-4 right-0">
                        <button
                            onClick={onClick}
                            className="h-8 w-8 grow grid place-content-center p-6 rounded-md group-hover:bg-woodyBrown group-hover:text-lightPeach transition"
                        >
                            <EditIcon className="w-8 h-8" />
                        </button>
                    </div>
                )}
            </div>
            <hr className="w-full border-woodyBrown opacity-30" />
        </div>
    );
};
